import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoursesService } from 'src/app/services/courses.service';
import { RouterModule } from '@angular/router';
import { CertificatesService } from 'src/app/services/certificates.service';
import { DataCourse } from 'src/app/shared/interfaces/course.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-grades',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './grades.component.html',
  styleUrls: ['./grades.component.scss']
})
export class GradesComponent {
  hasGrades: boolean = true;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public courses:CoursesService, private certificatesService: CertificatesService){}

  ngOnInit(){
    if(this.courses.filteredCourses.length === 0){
      this.hasGrades = false;
    }
    this.courses.courses$.pipe(takeUntil(this.destroy$)).subscribe(
      {
        next: courses => {
          this.associateCertificatesToCourses(courses);
        },
        error: error => {
          console.error('Error trayendo los cursos para las notas', error)
        }
      }
    )
  }

  private associateCertificatesToCourses(courses: DataCourse[]){
    courses.forEach(course => {
        const certificate = this.certificatesService.certificates.find((certificate:any) => certificate.courseId === course.attributes.drupal_internal__nid);
        if (certificate) {
          course.certificate = certificate;
        }
    });
    if(courses.length > 0){
      this.hasGrades = true;
    }
    return courses;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
